<div class="m-content">
  <div class="row">
    <div class="col-md-12">
      <!--begin::Portlet-->
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h4 class="m-portlet__head-text">Change Password</h4>
              <p class="errMessage"> </p>
            </div>
          </div>
        </div>
        <div class="m-portlet__body">
          <form class="m-form m-form--fit m-form--label" [formGroup]="updatePasswordForm">
            <div class="form-group m-form__group row">
              <label for="tp-details" class="col-3 col-form-label">
                New Password:
                <span class="mandatoryColor">*</span>
              </label>
              <div class="col-9">
                <input class="form-control m-input"[type]="showPassword ? 'text' : 'password'" formControlName="password"
                  placeholder="Enter new password" >
                  <span class="showPassword text-right pr-4" (click)="showPassClick()" aria-hidden="true">{{showPassword ? 'Hide' : 'Show'}}</span>
                <app-form-control-messages [control]="updatePasswordForm.controls.password"
                  [name]="'Password'"></app-form-control-messages>
              </div>
            </div>
            
            <div class="form-group m-form__group row">
              <label for="tp-details" class="col-3 col-form-label">
                Confirm Password:
                <span class="mandatoryColor">*</span>
              </label>
              <div class="col-9">
                <input class="form-control m-input" type="password" placeholder="Enter Confirm Password"
                name="confirmPassword" onpaste="return false" formControlName="confirmPassword">
                <app-form-control-messages [control]="updatePasswordForm.controls.confirmPassword" [name]="'confirm Password'">
                </app-form-control-messages>
                <div
                *ngIf="updatePasswordForm.controls['confirmPassword'].errors?.MatchPassword && passwordResetForm.controls['confirmPassword'].touched"
                class="red">Passwords do not match</div>
              </div>
            </div>
            <div class="m-portlet__foot m-portlet__foot--fit">
              <div class="m-form__actions">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-10 text-center">
                    <button type="button" data-toggle="modal" data-target="#spoc-popup" class="btn btn-next"
                      (click)="sendOTP()" [disabled]="!updatePasswordForm.valid">
                      Send OTP
                    </button>
                    <button type="button" class="btn btn-default marTop" (click)="back()">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="verify-otp" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Verify OTP
        </h5>
        <button type="button" class="close" aria-label="Close" #closeModel data-dismiss="modal">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div class="modal-body">
        <form class="m-form m-form--fit m-form--label-align-right" [formGroup]="verifyOTPForm">
          <div class="form-group m-form__group row">
            <label for="tp-details" class="col-3 col-form-label">
              Enter Mobile One Time Password:
              <span class="mandatoryColor">*</span>
            </label>
            <div class="col-9">
              <input class="form-control m-input" type="text" formControlName="mobileOTP"
                placeholder="Enter mobile one time password" maxlength="6">
              <app-form-control-messages [control]="verifyOTPForm.controls.mobileOTP"
                [name]="'Mobile One Time Password'"></app-form-control-messages>
            </div>
          </div>
          <!-- <div class="form-group m-form__group">
            <h6 class="text-center otp-or"><b>OR</b></h6>
          </div> -->
          <div class="form-group m-form__group row">
            <label for="tp-details" class="col-3 col-form-label">
              Enter Email One Time Password:
              <span class="mandatoryColor">*</span>
            </label>
            <div class="col-9">
              <input class="form-control m-input" type="text" formControlName="emailOTP"
                placeholder="Enter email one time password" maxlength="6">
              <app-form-control-messages [control]="verifyOTPForm.controls.emailOTP" [name]="'Email One Time Password'">
              </app-form-control-messages>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-next verifybutton" (click)="setPassword()" [disabled]="verifyOTPForm.invalid">
          Verify
        </button>
        <button type="button" class="btn  btn-cancel" data-dismiss="modal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
